module.exports = __webpack_public_path__ + "img/image14.b93db962.png";